import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import { BiSolidDashboard } from "react-icons/bi";
import { MdDirectionsCarFilled } from "react-icons/md";
import { BsCarFrontFill } from "react-icons/bs";
import { RiHotelFill, RiHotelLine } from "react-icons/ri";
import { FaPassport } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import "./drawer.css";
import LogoutIcon from "@mui/icons-material/Logout";
import { Avatar } from "antd";
import { VscLayoutActivitybarLeft } from "react-icons/vsc";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useSelector } from "react-redux";

export default function Drawer1({ showDrawer, setShowDrawer }) {
  const [DashboardName, setDashboardName] = React.useState("");

  React.useEffect(() => {
    const savedData = localStorage.getItem("UserName");
    if (savedData) {
      setDashboardName(JSON.parse(savedData));
    }
  }, []);

  const data = useSelector((state) => state.Country.dashboardData);
  console.log("dashdataNmae>>>>>>>>>>>", data);

  const navigate = useNavigate();

  const logout = (e) => {
    e.preventDefault();
    localStorage.removeItem("token");
    localStorage.removeItem("RememberMe");
    localStorage.removeItem("UserName");
    navigate("/login");
  };

  const [state, setState] = React.useState({
    left: showDrawer,
  });

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      setShowDrawer(false);
      return;
    }
    setShowDrawer(false);
    setState({ ...state, left: open });
  };

  const list = (anchor) => (
    <Box
      sx={{
        width: anchor === "top" || anchor === "bottom" ? "auto" : 250,
        overflowY: "auto",
      }}
      role="presentation"
    >
      <div className="drawer-wrapper">
        {/* Top bar with avatar */}
        <div
          style={{
            backgroundColor: "#14A44D",
            display: "flex",
            alignItems: "center",
            padding: "10px",
            gap: "8px",
            width: "100%",
          }}
        >
          <Avatar className="profile" alt="Remy Sharp" src={window.profile} />
          <p className="mt-1 text-light">{DashboardName}</p>
        </div>

        {/* Normal link */}
        <Link to="/dashboard" onClick={() => setShowDrawer(false)}>
          <BiSolidDashboard /> Dashboard
        </Link>

    <Link to="/not-arrange" onClick={() => setShowDrawer(false)}>
              <RiHotelFill /> Not Arranged
            </Link>
        {/* Allow hotel */}
        <Accordion
          disableGutters
          sx={{
            boxShadow: "none",
            backgroundColor: "transparent",
            "&:before": { display: "none" },
            marginRight:"2px"
          }}
        >
        
          <AccordionSummary expandIcon={<ExpandMoreIcon />} style={{paddingLeft:"10px"}}>
            <RiHotelFill style={{ marginRight: "4px" ,marginTop:"2px",width:"18px",height:"18px",color:"#694525"}} />
            <h5 style={{fontSize:"18px",color:"#694525"}}>

            Allow Hotels
            </h5>
          </AccordionSummary>
          <AccordionDetails
            sx={{ display: "flex", flexDirection: "column", gap: "4px", }}
          >
          
            <Link to="/allow-hotel-makkah" onClick={() => setShowDrawer(false)}>
              <RiHotelFill /> Allow Hotel Makkah
            </Link>
            <Link
              to="/allow-hotel-madina"
              onClick={() => setShowDrawer(false)}
            >
              <RiHotelLine /> Allow Hotel Medina
            </Link>
          </AccordionDetails>
        </Accordion>

{/* actual hotel  */}


 <Accordion
          disableGutters
          sx={{
            boxShadow: "none",
            backgroundColor: "transparent",
            "&:before": { display: "none" },
            marginRight:"2px"
          }}
        >
        
          <AccordionSummary expandIcon={<ExpandMoreIcon /> } style={{paddingLeft:"10px"}}>
            <RiHotelFill style={{ marginRight: "4px" ,marginTop:"2px",width:"18px",height:"18px",color:"#694525"}} />
            <h5 style={{fontSize:"18px",color:"#694525"}}>

            CheckIn Hotels
            </h5>
          </AccordionSummary>
          <AccordionDetails
            sx={{ display: "flex", flexDirection: "column", gap: "4px",padding:"0px 16px" }}
          >
          
            <Link to="/checkin-makkah-hotel" onClick={() => setShowDrawer(false)}>
              <RiHotelFill /> Checkin Hotel Makkah 
            </Link>
            <Link
              to="/checkin-madina-hotel"
              onClick={() => setShowDrawer(false)}
            >
              <RiHotelLine /> Checkin Hotel Medina
            </Link>
          </AccordionDetails>
        </Accordion>




{/* allow transport  */}
 <Accordion
          disableGutters
          sx={{
            boxShadow: "none",
            backgroundColor: "transparent",
            "&:before": { display: "none" },
            marginRight:"2px"
          }}
        >
        
          <AccordionSummary expandIcon={<ExpandMoreIcon /> } style={{paddingLeft:"10px"}}>
            <MdDirectionsCarFilled  style={{ marginRight: "4px" ,marginTop:"2px",width:"18px",height:"18px",color:"#694525"}} />
            <h5 style={{fontSize:"18px",color:"#694525"}}>

            Allow Transport
            </h5>
          </AccordionSummary>
          <AccordionDetails
            sx={{ display: "flex", flexDirection: "column", gap: "4px",padding:"0px 16px" }}
          >
          
            <Link to="/allow-makkah-tpt" onClick={() => setShowDrawer(false)}>
              <MdDirectionsCarFilled  /> Allow Makkah Tpt
            </Link>
            <Link
              to="/allow-madina-tpt"
              onClick={() => setShowDrawer(false)}
            >
              <MdDirectionsCarFilled  /> Allow Medina Tpt
            </Link>

              <Link
              to="/allow-jeddah-tpt"
              onClick={() => setShowDrawer(false)}
            >
              <MdDirectionsCarFilled  /> Allow Jeddah Tpt
            </Link>





          </AccordionDetails>
        </Accordion>



{/* actual transport  */}

 <Accordion
          disableGutters
          sx={{
            boxShadow: "none",
            backgroundColor: "transparent",
            "&:before": { display: "none" },
            marginRight:"2px"
          }}
        >
        
          <AccordionSummary expandIcon={<ExpandMoreIcon /> } style={{paddingLeft:"10px"}}>
            <MdDirectionsCarFilled  style={{ marginRight: "4px" ,marginTop:"2px",width:"18px",height:"18px",color:"#694525"}} />
            <h5 style={{fontSize:"18px",color:"#694525"}}>

            Actual Transport
            </h5>
          </AccordionSummary>
          <AccordionDetails
            sx={{ display: "flex", flexDirection: "column", gap: "4px",padding:"0px 16px" }}
          >
          
            <Link to="/actual-makkah-tpt" onClick={() => setShowDrawer(false)}>
              <MdDirectionsCarFilled  /> Actual  Makkah Tpt 
            </Link>

            <Link
              to="/actual-madina-tpt"
              onClick={() => setShowDrawer(false)}
            >
              <RiHotelLine /> Actual  Medina Tpt 
            </Link>



  <Link
              to="/actual-jeddah-tpt"
              onClick={() => setShowDrawer(false)}
            >
              <RiHotelLine /> Actual  Jeddah Tpt 
            </Link>


          </AccordionDetails>
        </Accordion>

        {/* Other links */}
        <Link to="/single-allow-activity" onClick={() => setShowDrawer(false)}>
          <VscLayoutActivitybarLeft style={{ marginRight: "4px" }} />
          Select Activity
        </Link>

        <Link to="/upload-passport" onClick={() => setShowDrawer(false)}>
          <FaPassport /> Upload Passport
        </Link>
      </div>

      <footer>
        <button
          onClick={logout}
          className="drawer-logout-button d-flex justify-content-center align-self-center bg-danger"
        >
          <LogoutIcon
            sx={{
              color: "white",
              fontSize: "20px",
              marginTop: "3px",
            }}
          />{" "}
          <span className="fs-2 text-light">Logout</span>
        </button>
      </footer>
    </Box>
  );

  return (
    <div>
      <React.Fragment key="left">
        <Drawer
          anchor="left"
          open={state.left}
          onClose={toggleDrawer(false)}
          sx={{
            "& .MuiDrawer-paper": {
              paddingBottom: "50px",
            },
          }}
        >
          {list("left")}
        </Drawer>
      </React.Fragment>
    </div>
  );
}
